import React, { useState, useEffect } from 'react'
import Graph from './Graph'
import styled from 'styled-components'
import { StyledButton } from './styles'

export default function Question({ question, onNext }) {
  const [guessed, setGuessed] = useState(null)

  useEffect(() => {
    setGuessed(null)
  }, [question])

  const onGuess = (correct) => {
    setGuessed(correct)
  }

  const onNextClick = () => {
    onNext(guessed)
  }

  return (
    <QuestionWrapper>
      <Graph show={question.show} />
      <Options>
        {guessed !== null && (
          <NextWrapper>
            <StyledButton onClick={onNextClick}>Next</StyledButton>
          </NextWrapper>
        )}
        {question.options.map((opt) => (
          <StyledButton
            key={opt.title}
            onClick={() => onGuess(opt.correct)}
            color={color(opt, guessed)}
            disabled={guessed !== null}
          >
            {opt.title}
          </StyledButton>
        ))}
      </Options>
    </QuestionWrapper>
  )
}

const color = (option, guessed) => {
  if (guessed === null) return null

  if (option.correct) {
    return guessed ? 'green' : 'red'
  }

  return 'grey'
}

const QuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  margin-bottom: 1rem;
  width: 100%;
`

const Options = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1000px;

  > * {
    margin: 8px 4px;
  }
`

const NextWrapper = styled.div`
  position: absolute;
  transform: translateY(-150%);
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 0;
`
